import { hubApi } from '@/app/api/hubApi';
import type { PublicSurvey, SubmitPayload } from './types';

interface SurveyRef {
  restaurantUuid: string;
  surveyUuid: string;
}

// SC-1752 — public, anonymous endpoints (hub `customer_feedback`). The identity
// endpoint `/restaurants/public/<uuid>/` is NOT used: it 404s when online
// ordering is off, whereas the survey payload carries theme, name and logo.
// A POST that never answers must end: the guest gets the retry banner instead of a frozen button.
export const SUBMIT_TIMEOUT_MS = 20_000;

export const surveyApi = hubApi.injectEndpoints({
  endpoints: (build) => ({
    getPublicSurvey: build.query<PublicSurvey, SurveyRef>({
      query: ({ restaurantUuid, surveyUuid }) =>
        `/feedback/public/${encodeURIComponent(restaurantUuid)}/${encodeURIComponent(surveyUuid)}/`,
    }),
    submitSurveyResponse: build.mutation<{ uuid: string }, SurveyRef & { body: SubmitPayload }>({
      query: ({ restaurantUuid, surveyUuid, body }) => ({
        url: `/feedback/public/${encodeURIComponent(restaurantUuid)}/${encodeURIComponent(surveyUuid)}/responses/`,
        method: 'POST',
        body,
        timeout: SUBMIT_TIMEOUT_MS,
      }),
    }),
  }),
});

export const { useGetPublicSurveyQuery, useSubmitSurveyResponseMutation } = surveyApi;
